import { format, isToday } from 'date-fns';
import React, { memo, useMemo } from 'react';
import { Text, useWindowDimensions, View } from 'react-native';

import { GeneralFunctions } from '@/helpers/GeneralFunctions';
import type { ISyncList } from '@/libs/types/sync';

import { mapInterviewStatus } from '../../helpers/interviewStatus';
import { styles } from './styles';

type ICardProps = {
  interviews: ISyncList[];
};

function CardComponent({ interviews }: ICardProps) {
  const { width } = useWindowDimensions();
  const isMobile = width < 540;

  const totalInterviews = interviews.length;

  const validInterviews = interviews.filter(
    (interview) => mapInterviewStatus(interview) === 'Válida',
  );

  const notConsideredInterviews = interviews.filter(
    (interview) => mapInterviewStatus(interview) === 'Não Considerada',
  ).length;

  const validInterviewsToday = validInterviews.filter((interview) =>
    isToday(new Date(interview.created_at)),
  ).length;

  const workedDays = useMemo(() => {
    if (interviews.length === 0) return 0;

    return new Set(
      interviews.map((interview) =>
        format(new Date(interview.created_at), 'yyyy-MM-dd'),
      ),
    ).size;
  }, [interviews]);

  const averageInterviewsCompletedDay = useMemo(() => {
    if (validInterviews.length === 0 || workedDays === 0) return 0;

    return GeneralFunctions.roundedNumber(
      validInterviews.length / workedDays,
      2,
    );
  }, [validInterviews.length, workedDays]);

  return (
    <View style={[styles.container, isMobile && styles.containerMobile]}>
      <View
        style={[styles.cardContainer, isMobile && styles.cardContainerMobile]}
      >
        <Text style={styles.number}>{totalInterviews}</Text>
        <Text style={styles.label}>Total de entrevistas no período</Text>
      </View>
      <View
        style={[styles.cardContainer, isMobile && styles.cardContainerMobile]}
      >
        <Text style={styles.number}>{validInterviews.length}</Text>
        <Text style={styles.label}>Total de entrevistas válidas</Text>
      </View>
      <View
        style={[styles.cardContainer, isMobile && styles.cardContainerMobile]}
      >
        <Text style={styles.number}>{notConsideredInterviews}</Text>
        <Text style={styles.label}>Total de entrevistas não consideradas</Text>
      </View>
      <View
        style={[styles.cardContainer, isMobile && styles.cardContainerMobile]}
      >
        <Text style={styles.number}>{validInterviewsToday}</Text>
        <Text style={styles.label}>Entrevistas válidas hoje</Text>
      </View>
      <View
        style={[styles.cardContainer, isMobile && styles.cardContainerMobile]}
      >
        <Text style={styles.number}>{averageInterviewsCompletedDay}</Text>
        <Text style={styles.label}>Média de entrevistas válidas/dia</Text>
      </View>
      <View
        style={[styles.cardContainer, isMobile && styles.cardContainerMobile]}
      >
        <Text style={styles.number}>{workedDays}</Text>
        <Text style={styles.label}>Dias trabalhados</Text>
      </View>
    </View>
  );
}

export const Card = memo(CardComponent);
